import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import Bank from "../../img/bank.jpg";
import Restaurants from "../../img/restaurants.png";
import Hospital from "../../img/hospital.png";
import Movies from "../../img/movies.png";
import Alexa from "../../img/alexa.png";
import Budget from "../../img/budget.png";
import PCShop from "../../img/pc.png";
import MultiLingual from "../../img/multi.png";
import Dashboard from "../../img/dashboard.png";
import Rent from "../../img/rent.jpg";
import Restaurant from "../../img/restaurant.png";
import Blog from "../../img/blog.jpg";
import Lisbon from "../../img/lisbon.jpg";
import World from "../../img/world.jpg";
import Space from "../../img/space.png";
import Books from "../../img/books.jpg";
import Todo from "../../img/todo.png";
import Recipe from "../../img/recipe.jpg";
import Recipes from "../../img/recipes.png";
import Catalog from "../../img/catalog.png";
import Vet from "../../img/vet.png";
import Calculator from "../../img/calculator.png";
import Time from "../../img/time.png";
import Markdown from "../../img/markdown.png";
import Drum from "../../img/drum.png";
import { themeContext } from "../../Context";

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Restaurants App</h2></small><small className="project-techologies"><h3>Ruby on Rails Google maps</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/bank-app-rails"><img className="budget" src={Restaurants} alt="" /></a>
        </span>
        </SwiperSlide>

        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Bank App</h2></small><small className="project-techologies"><h3>Ruby on Rails</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/bank-app-rails"><img className="budget" src={Bank} alt="" /></a>
        </span>
        </SwiperSlide>
      
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Mayo Clinic</h2></small><small className="project-techologies"><h3>Ruby on Rails</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/hospital"><img className="budget" src={Hospital} alt="" /></a>
        </span>
        </SwiperSlide>
  
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Watch Movies</h2></small><small className="project-techologies"><h3>Rect-redux, REST-API</h3></small>
        <a target="_blank" rel="noreferrer" href="https://ghttps://github.com/VuDej/watch-movies/"><img className="budget" src={Movies} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>React Alexa</h2></small><small className="project-techologies"><h3>Rect-redux, Alan-AI</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/react-alexa"><img className="budget" src={Alexa} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>PC Shop</h2></small><small className="project-techologies"><h3>Rect-redux, Firebase</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/pc-shop"><img className="budget" src={PCShop} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Budget</h2></small><small className="project-techologies"><h3>Rails, PostgreSQL</h3></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/budget-app-rails"><img className="budget" src={Budget} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Cars</h2></small><small className="project-techologies"><h2>Rails, React, PostgreSQL</h2></small>
        <a target="_blank" rel="noreferrer" href="https://frontend-dejan-rentacar.herokuapp.com"><img className="budget" src={Rent} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Restaurant</h2></small><small className="project-techologies"><h2>Rails, React, PostgreSQL</h2></small>
        <a target="_blank" rel="noreferrer" href="https://restaurant-dejan-frontend.netlify.app/"><img className="budget" src={Restaurant} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Advanced Dashboard</h2></small><small className="project-techologies"><h2>React</h2></small>
        <a target="_blank" rel="noreferrer" href="https://admin-dejan-dashboard.netlify.app/"><img className="budget" src={Dashboard} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Blog</h2></small><small className="project-techologies"><h2>Rails, PostgreSQL</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/Blog"><img className="budget" src={Blog} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Meeting</h2></small><small className="project-techologies"><h2>Javascript, CSS3</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/Web-Summit-2022-Lisbon"><img className="budget" src={Lisbon} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>World</h2></small><small className="project-techologies"><h2>React, API</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/world-app"><img className="budget" src={World} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Multi Lingual app</h2></small><small className="project-techologies"><h2>React, I18nexus</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/multi-lingual"><img className="budget" src={MultiLingual} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Space</h2></small><small className="project-techologies"><h2>React, API</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/Nuri1977/space-travelers-hub"><img className="budget" src={Space} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Books</h2></small><small className="project-techologies"><h2>Javascript, API</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/Awesome-Books-ES6"><img className="budget" src={Books} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Todo</h2></small><small className="project-techologies"><h2>Javascript, API</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/To-Do-list"><img className="budget" src={Todo} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Recipe</h2></small><small className="project-techologies"><h2>Rails, PostgreSQL</h2></small>
        <a target="_blank" rel="noreferrer" href="https://recipe-dejan.herokuapp.com/"><img className="budget" src={Recipe} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Recipes</h2></small><small className="project-techologies"><h2>Javascript, API</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/Capstone-2-JavaScript"><img className="budget" src={Recipes} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Calculator</h2></small><small className="project-techologies"><h2>React, Redux</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/Math-Magicians"><img className="budget" src={Calculator} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Pomodoro</h2></small><small className="project-techologies"><h2>React, CSS3</h2></small>
        <a target="_blank" rel="noreferrer" href="https://vudej.github.io/Time-Managment/"><img className="budget" src={Time} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Markdown</h2></small><small className="project-techologies"><h2>React, CSS3</h2></small>
        <a target="_blank" rel="noreferrer" href="https://vudej.github.io/Markdown-Previewer/"><img className="budget" src={Markdown} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Drums</h2></small><small className="project-techologies"><h2>React, CSS3</h2></small>
        <a target="_blank" rel="noreferrer" href="https://vudej.github.io/Drum-Machine/"><img className="budget" src={Drum} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Catalog</h2></small><small className="project-techologies"><h2>Ruby, JSON</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/My-catalog-ruby-console"><img className="budget" src={Catalog} alt="" /></a>
        </span>
        </SwiperSlide>
        <SwiperSlide>
        <span className="project-wrapper"><small className="title"><h2>Clinic</h2></small><small className="project-techologies"><h2>Ruby, JSON</h2></small>
        <a target="_blank" rel="noreferrer" href="https://github.com/VuDej/vet_clinic"><img className="budget" src={Vet} alt="" /></a>
        </span>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
